// extracted by mini-css-extract-plugin
export default {"pinchIcon":"zld40hcR7JaGne7csmr_","tooltip":"YbG5KrkCn1QsBorEhjVz"};